import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AppProviders } from "./AppProviders";
import ScrollToTop from "./utils/scrollToTop";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(), // 👈 add this
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1, // record 10% of normal sessions
  replaysOnErrorSampleRate: 1.0, // record 100% of sessions with errors
  tracePropagationTargets: ["localhost", /^https:\/\/api\.wswinner\.com/],
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <ScrollToTop />
    <React.StrictMode>
      <HelmetProvider>
        <AppProviders>
          <Sentry.ErrorBoundary fallback={<p>An unexpected error occurred.</p>}>
            <App />
          </Sentry.ErrorBoundary>
        </AppProviders>
      </HelmetProvider>
    </React.StrictMode>
  </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
